document.addEventListener('DOMContentLoaded', () => {
    const productInfo = document.querySelector('.product__info');
    const productMedia = document.querySelector('.product__media');
    const mediaDetailsSection = document.querySelector('.product-media-details-section');
    const autoScrollContainer = document.querySelector('.auto-scroll-products-container');

    if (!productInfo || !productMedia || !mediaDetailsSection) {
        return;
    }

    const mainImageContainer = productMedia.querySelector('.product__media-list-wrapper');
    const mainTitle = productInfo.querySelector('h1.product-meta__title');
    const mainPrice = productInfo.querySelector('.product-meta__price-list-container .price-list');
    const mainDescription = productInfo.querySelector('[data-product-description]');

    const detailItems = mediaDetailsSection.querySelectorAll('.product-media-detail-item');

    if (!mainImageContainer || !mainTitle || !mainPrice || detailItems.length === 0) {
        return;
    }

    const originalImageHTML = mainImageContainer.innerHTML;
    const originalTitleHTML = mainTitle.innerHTML;
    const originalPriceHTML = mainPrice.innerHTML;
    const originalDescriptionHTML = mainDescription ? mainDescription.innerHTML : '';
    let isOriginalState = true;

    function updateProductOnScroll() {
        let activeItem = null;

        for (const item of detailItems) {
            const rect = item.getBoundingClientRect();
            if (rect.top <= window.innerHeight / 2 && rect.bottom >= window.innerHeight / 2) {
                activeItem = item;
                break;
            }
        }

        if (activeItem) {
            if (isOriginalState) {
                isOriginalState = false;
            }

            const newImage = activeItem.querySelector('.product-media-detail-image img');
            const newTitle = activeItem.querySelector('.product-media-detail-title');
            const newPrice = activeItem.querySelector('.product-media-detail-price');
            const newDescription = activeItem.querySelector('.product-media-detail-description');

            if (newImage) {
                const aspectRatio = (newImage.height / newImage.width) * 100;
                mainImageContainer.innerHTML = `
                    <div class="product__media-item is-selected" style="width: 100%;">
                        <div class="product__media-image-wrapper aspect-ratio aspect-ratio--natural" style="padding-bottom: ${aspectRatio}%;">
                            <img src="${newImage.src}" srcset="${newImage.srcset}" sizes="${newImage.sizes}" alt="${newImage.alt}" width="${newImage.width}" height="${newImage.height}">
                        </div>
                    </div>`;
            }

            if (newTitle) {
                mainTitle.innerHTML = newTitle.innerHTML;
            }

            if (newPrice) {
                mainPrice.innerHTML = newPrice.innerHTML;
            }

            if (mainDescription) {
                if (newDescription) {
                    mainDescription.innerHTML = newDescription.innerHTML;
                } else {
                    mainDescription.innerHTML = ''; // Clear description if the block doesn't have one
                }
            }

        } else {
            if (!isOriginalState) {
                mainImageContainer.innerHTML = originalImageHTML;
                mainTitle.innerHTML = originalTitleHTML;
                mainPrice.innerHTML = originalPriceHTML;
                if (mainDescription) {
                    mainDescription.innerHTML = originalDescriptionHTML;
                }
                isOriginalState = true;

                const flickityElement = mainImageContainer.querySelector('flickity-carousel');
                if (flickityElement) {
                    const flickityInstance = Flickity.data(flickityElement);
                    if (flickityInstance) {
                        flickityInstance.reloadCells();
                        flickityInstance.resize();
                    }
                }
            }
        }
    }

    window.addEventListener('scroll', updateProductOnScroll, { passive: true });
});
